import { useParams } from "react-router";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellLink from "ds/components/Table/Row/CellLink";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import { Commit } from "components/icons/generated";
import { RepoFile } from "types/generated";
import { getRepoRevisionUrl } from "utils/spaceliftRepo";

const CommitCell = ({ item, ...cellProps }: TableSimpleCellProps<RepoFile>) => {
  const { repoId } = useParams<{ repoId: string }>();

  return (
    <TableSimpleCell {...cellProps}>
      {item.revision.sha ? (
        <Box direction="row" align="center" gap="small">
          <Icon src={Commit} color="info" noShrink />
          <TableCellLink href={getRepoRevisionUrl(repoId!, item.revision.sha)} variant="primary">
            {item.revision.sha.slice(0, 7)}
          </TableCellLink>
        </Box>
      ) : (
        <TableCellEmpty />
      )}
    </TableSimpleCell>
  );
};

export default CommitCell;
